<template>
  <div>
    <div class="bg">
      <div class="netBg"></div>
      <Map ref="map" :currentCount="currentCount" :currentType="currentType"></Map>
      <div class="transparencyBG"></div>
      <div class="individualMessage">
        <Icon type="ios-person-add" class="personIcon"/>
        <span class="userName">{{ userName }},欢迎您</span>
        <span class="exit">
         <Icon type="md-power" @click="userExit"/>
        </span>
      </div>
      <div class="bgTitle">
        <p class="title">{{ systemName }}</p>
        <p class="select_county">
          <Select v-model="currentCount">
            <Option v-for="(item,index) in countList" :label="item.name" :value="item.indexCode" :key="index"></Option>
          </Select>
        </p>
      </div>
      <div class="btnBox">
        <Row>
          <Col v-for="(item , index) in btnList" :key="index" :span="5">
            <RouterLink :to="{name:item.name}">
              <p class="btns" :class="{'btn_yellow':activeBtns===index}" @click="btnActive(index)">{{ item.title }}</p>
            </RouterLink>
          </Col>
        </Row>
      </div>
      <div class="leftInfoBox">
        <div class="leftBox">
          <div class="leftTopBox" @click="goCloudMap">
            <Weather></Weather>
          </div>
          <div class="leftCenterBox">
            <RoadDynamics v-if="activeBtns===0||activeBtns===1" @orientation="centerZoom"></RoadDynamics>
            <!--            <EarlyWarning v-if="activeBtns===1" @orientation="centerZoom"></EarlyWarning>-->
            <!--            <RoadDynamicsItem v-if="activeBtns===2"></RoadDynamicsItem>-->
            <EmergencyEmergencyDynamics ref="EmergencyEmergencyDynamics" @getEventById="getEventTimeLineById"
                                        v-if="activeBtns===2"></EmergencyEmergencyDynamics>
          </div>
          <div class="leftBottomBox">
            <EventStatistics v-if="activeBtns===0"></EventStatistics>
            <!--            <EventStatistics v-if="activeBtns===1"></EventStatistics>-->
            <!--            <EventStatistics v-if="activeBtns===1"></EventStatistics>-->
            <RoadStatistics v-if="activeBtns===1"></RoadStatistics>
            <EmergencyStatistics v-if="activeBtns===2"></EmergencyStatistics>
          </div>
        </div>
        <div class="rightBox">
          <div class="roadLegend">
            <div class="box">
              <div class="road" style="background: #f8091e"></div>
              <div class="textBox"><span class="text">国道</span></div>
            </div>
            <div class="box">
              <div class="road" style="background: #1ba7ff"></div>
              <div class="textBox"><span class="text">省道</span></div>
            </div>
            <div class="box">
              <div class="road" style="background: #ff6200"></div>
              <div class="textBox"><span class="text">高速</span></div>
            </div>
          </div>
          <div class="mapType">
            <div class="WithinBox">
              <div class="mapTypeItem" v-for="(item,index) in typeList"
                   :key="index"
                   :class="{mapTypeItemActive:active===index}"
                   @click="typeActive(item,index)"
              ><span>{{ item }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      这里是右边的-->
      <div class="rightInfoBox">
        <div class="rightBox">
          <div class="rightTopBox1">
            <!--            <VideoSurveillance></VideoSurveillance>-->
          </div>
          <div class="rightTopBox">
            <EventDynamic v-if="activeBtns===0" @center="centerZoom" @getEventById="getEventDynamic"></EventDynamic>
            <eventStatistics :indexCode="currentCount" v-if="activeBtns===1"></eventStatistics>
            <EmergencyEmergencyTimeline ref="EmergencyEmergencyTimeline"
                                        v-if="activeBtns===2"></EmergencyEmergencyTimeline>
          </div>
          <div class="rightBottomBox">
            <Resources v-if="activeBtns===0||activeBtns===2"></Resources>
            <MileageStatistics v-if="activeBtns===1"></MileageStatistics>
          </div>
        </div>
        <div class="leftBox">
          <Legend></Legend>
        </div>
      </div>
      <div v-if="exitModal" class="exitModal">
        <div class="top">
          <Icon type="md-close" class="icon" @click="exitModal=false"/>
          <span>退出系统</span>
        </div>
        <div class="content">
          确认退出系统？
        </div>
        <div class="footer">
          <div class="exitBtn">
            <p @click="exit">退出</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 天气组件
import Weather from "@/views/Screen/components/Weather/Weather";
// 应急
import EarlyWarning from "@/views/Screen/components/EarlyWarning/EarlyWarning";
// 事件统计
import EventStatistics from "@/views/Screen/components/EventStatistics/EventStatistics";
// 事件动态
import EventDynamic from "@/views/Screen/components/EventDynamic/EventDynamic";
// 应急资源
import Resources from "@/views/Screen/components/Resources/Resources";
// 地图
import Map from "@/views/Screen/components/Map/Map";
// 图例
import Legend from "@/views/Screen/components/Legend/Legend";
// 路网动态
import RoadDynamics from "@/views/Screen/components/RoadDynamics/RoadDynamics";
// 路况统计
import RoadStatistics from "@/views/Screen/components/RoadStatistics/RoadStatistics.vue";
// 路网动态下的路网动态
import RoadDynamicsItem from "@/views/Screen/components/road/RoadDynamics/RoadDynamics.vue";
// 里程统计
import MileageStatistics from "@/views/Screen/components/MileageStatistics/MileageStatistics";
// 应急管理下的应急事件
import EmergencyEmergencyDynamics
  from "@/views/Screen/components/EmergencyEmergencyDynamics/EmergencyEmergencyDynamics";
// 应急管理下的应急时间线
import EmergencyEmergencyTimeline
  from "@/views/Screen/components/EmergencyEmergencyDynamics/EventTimeLine.vue";
//
import eventStatistics from "@/views/Screen/components/MileageStatistics/eventStatistics.vue"
// 应急管理下的echarts
import EmergencyStatistics from "@/views/Screen/components/EmergencyStatistics/EmergencyStatistics.vue";

export default {
  components: {
    Weather,
    Map,
    EarlyWarning,
    EmergencyStatistics,
    EventStatistics,
    EventDynamic,
    Resources,
    Legend,
    RoadDynamics,
    RoadStatistics,
    RoadDynamicsItem,
    MileageStatistics,
    EmergencyEmergencyDynamics,
    EmergencyEmergencyTimeline,
    eventStatistics
  },
  name: "Screen",
  data() {
    return {
      activeBtns: 0,
      btnList: [
        {title: '总览', name: ''},
        {title: '路网管理', name: ''},
        {title: '应急管理', name: ''},
        {title: '数据管理', name: 'home'}],
      currentType: '地图',
      typeList: ['地图', '影像', '地形'],
      active: 0,
      exitModal: false,
      systemName: '德州市国省干线路网动态管理和应急指挥调度平台系统',
      userName: null,
      countList: [],
      currentCount: null
    }
  },
  watch: {
    activeBtns(val) {
      // this.$refs.map.getEventList()
      this.$refs.map.removeOverlay()
      this.$refs.map.changeCurrent()
    }
  },
  mounted() {
    this.getUserData()
    this.getCounty()
  },
  methods: {
    getEventTimeLineById(item) {
      // 定位到地图中心点
      this.$refs.map.map.centerAndZoom(new BMapGL.Point(item.longitude, item.latitude), 16);
      this.$refs.EmergencyEmergencyTimeline.getEventById(item)
      // 显示点位
      this.$refs.map.addMarker(item)
    },
    getEventDynamic(item) {
      // 定位到地图中心点
      this.$refs.map.map.centerAndZoom(new BMapGL.Point(item.longitude, item.latitude), 16);
      // this.$refs.EmergencyEmergencyTimeline.getEventById(item)
      // 显示点位
      this.$refs.map.addMarker(item)
    },
    btnActive(index) {
      this.activeBtns = index
    },
    // 事件动态中心点
    centerZoom(item) {
      if (item.longitude && item.latitude) {
        let centerPoint = new BMapGL.Point(item.longitude, item.latitude);
        this.$refs.map.map.centerAndZoom(centerPoint, 16);
      } else {
        this.$Message.error('该事件没有经纬度')
      }
    },
    goCloudMap() {
      // this.$router.push({ name: 'CloudMap' })
    },
    typeActive(item, index) {
      this.currentType = item
      this.active = index
    },
    getUserData() {
      this.$http.get('/api/system/cscpCurrentUserDetails').then(res => {
        if (res.status === 200) {
          this.userName = res.data.name
        }
      })
    },
    // 获取区县
    getCounty() {
      this.$http.get('/api/getLowerLevelDepts?flag=3').then(res => {
        if (res.status === 200) {
          // this.countList = res.data
          this.currentCount = res.data[0].indexCode
          for (let i in res.data) {
            if (res.data[i].unitLevel !== 3) {
              this.countList.push(res.data[i])
            }
          }
        }
      })
    },
    userExit() {
      this.exitModal = true
    },
    exit() {
      console.log('退出')
      this.$store.commit('user/logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped lang="less">
@import './css/base.less';

html {
  height: 100%
}

body {
  height: 100%;
  margin: 0;
  padding: 0;
}


/deep/ .anchorBL {
  display: none
}
</style>
